import { Box } from "@mui/material";
import React from "react";
interface StatusDevolutionProps {
  devolutionData: devolutionData;
}
type devolutionData = {
  id: number;
  status_id: number;
  order_id: number;
  method_shipment: string;
  dateCreatedReturn: string;
  customer: {
    fullname: string;
    fone: string;
    cellphone: string;
    cep: string;
    state: string;
    city: string;
    neigh_borhood: string;
    street: string;
    number: string;
    complement: string;
  };
  products: Array<{
    name: string;
    image: string;
    quant: number;
    price: string;
    refundType: string;
    reasonSub: string;
    reasonMain: string;
    obs: string;
    variant: string;
    url_pdf: any;
  }>;
  history: Array<{
    title: string;
    date: string;
    fileIcon: string;
    status: string;
  }>;
  status: {
    title: string;
    status: string;
    msg: string;
    color: string;
  };
  coupon: any;
  ldn: {
    status: boolean;
    url: string;
  };
};

const StatusDevolution: React.FC<StatusDevolutionProps> = ({ devolutionData }) => {
  // console.log(devolutionData.history);
  let checkDesk = true;
  let checkMobile = true;
  return (
    <Box>
      {/* desktop */}
      <Box display={{ xs: "none", md: "block" }}>
        <Box display={"flex"} ml={10} width={900}>
          {devolutionData?.history.map((item, i) => {
            const historyOrdenad = Object.entries(devolutionData.history).map(([key, data]: any) => ({
              indexId: key,
              ...data,
            }));
            const test = historyOrdenad.filter((el) => el.status.length === 0);
            const itemAtual = test[0];

            if (checkDesk) {
              checkDesk = item.status.length == 0 ? false : true;
            }
            
            return (
              <Box key={i} display={"flex"} flexDirection={"column"} justifyContent={"center"} alignItems={"flex-start"} position={"relative"}>
                <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
                  {/* Bola */}
                  <Box>
                    {itemAtual?.indexId == i ? (
                      <Box
                        sx={{
                          width: "40px",
                          height: "40px",
                          backgroundColor: "#FCFCFC",
                          borderRadius: "50%",
                          border: "6px solid #C2282B",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                        }}>
                        <Box
                          sx={{
                            width: "25px",
                            height: "25px",
                            backgroundColor: "#C2282B",
                            borderRadius: "50%",
                          }}
                        />
                      </Box>
                    ) : (
                      <Box
                        sx={{
                          width: "43px",
                          height: "43px",
                          backgroundColor: checkDesk ? "#C2282B" : "#BDBEBF",
                          borderRadius: "50%",
                        }}
                      />
                    )}
                  </Box>
                  {/* Bola */}

                  {i < 4 ? (
                    <Box
                      sx={{
                        width: "150px",
                        height: "10px",
                        marginLeft: -0.2,
                        marginRight: -0.2,
                        backgroundColor: checkDesk ? "#C2282B" : "#BDBEBF",
                      }}
                    />
                  ) : null}
                </Box>
                {i == 0 ? (
                  <p style={{ fontWeight: itemAtual?.indexId == i ? 900 : 300, position: "absolute", bottom: -24, left: -50 }}>Solicitação Realizada</p>
                ) : null}
                {i == 1 ? (
                  <p style={{ fontWeight: itemAtual?.indexId == i ? 900 : 300, position: "absolute", bottom: -24, left: -35 }}>{item.status.length > 0 ? 'Envio realizado':'Envio pendente'}</p>
                ) : null}
                {i == 2 ? <p style={{ fontWeight: itemAtual?.indexId == i ? 900 : 300, position: "absolute", bottom: -24, left: -15 }}>Em análise</p> : null}
                {i == 3 ? <p style={{ fontWeight: itemAtual?.indexId == i ? 900 : 300, position: "absolute", bottom: -24, left: -15 }}>Reembolso</p> : null}
                {i == 4 ? <p style={{ fontWeight: itemAtual?.indexId == i ? 900 : 300, position: "absolute", bottom: -24, left: -10 }}>Conclusão</p> : null}
              </Box>
            );
          })}
        </Box>
      </Box>
      {/* desktop */}

      {/* mobile */}
      <Box display={{ xs: "block", md: "none" }}>
        <Box display={"flex"} mb={3}>
          {devolutionData?.history.map((item, i) => {
            const historyOrdenad = Object.entries(devolutionData.history).map(([key, data]: any) => ({
              indexId: key,
              ...data,
            }));
            const test = historyOrdenad.filter((el) => el.status.length === 0);
            const itemAtual = test[0];

            if (checkMobile) {
              checkMobile = item.status.length == 0 ? false : true;
            }

            return (
              <Box key={i} display={"flex"} flexDirection={"column"} justifyContent={"center"} alignItems={"flex-start"} position={"relative"}>
                <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
                  {/* Bola */}
                  <Box>
                    {itemAtual?.indexId == i ? (
                      <Box
                        sx={{
                          width: "30px",
                          height: "30px",
                          backgroundColor: "#FCFCFC",
                          borderRadius: "50%",
                          border: "6px solid #C2282B",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                        }}>
                        <Box
                          sx={{
                            width: "15px",
                            height: "15px",
                            backgroundColor: "#C2282B",
                            borderRadius: "50%",
                          }}
                        />
                      </Box>
                    ) : (
                      <Box
                        sx={{
                          width: "33px",
                          height: "33px",
                          backgroundColor: checkMobile ? "#C2282B" : "#BDBEBF",
                          borderRadius: "50%",
                        }}
                      />
                    )}
                  </Box>
                  {/* Bola */}

                  {i < 4 ? (
                    <Box
                      sx={{
                        width: "35px",
                        height: "10px",
                        marginLeft: -0.2,
                        marginRight: -0.2,
                        backgroundColor: checkMobile ? "#C2282B" : "#BDBEBF",
                      }}
                    />
                  ) : null}
                </Box>
                {itemAtual?.indexId == i ? (
                  <>
                    {i == 0 ? (
                      <p style={{ fontWeight: 900, position: "absolute", bottom: -35, left: -25, textAlign: "center" }}>Solicitação Realizada</p>
                    ) : null}
                    {i == 1 ? <p style={{ fontWeight: 900, position: "absolute", bottom: -35, left: -35, textAlign: "center" }}>Envio Realizado</p> : null}
                    {i == 2 ? <p style={{ fontWeight: 900, position: "absolute", bottom: -35, left: -25, textAlign: "center" }}>Em análise</p> : null}
                    {i == 3 ? <p style={{ fontWeight: 900, position: "absolute", bottom: -35, left: -25, textAlign: "center" }}>Reembolso</p> : null}
                    {i == 4 ? <p style={{ fontWeight: 900, position: "absolute", bottom: -35, left: -20, textAlign: "center" }}>Conclusão</p> : null}
                  </>
                ) : null}
              </Box>
            );
          })}
        </Box>
      </Box>
      {/* mobile */}
    </Box>
  );
};

export default StatusDevolution;
